import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = [
    "name"
];
const _hoisted_2 = [
    "title"
];
const _hoisted_3 = [
    "name"
];
const _hoisted_4 = [
    "title"
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_menu_item = _resolveComponent("el-menu-item");
    const _component_SubmenuListPc = _resolveComponent("SubmenuListPc");
    const _component_el_sub_menu = _resolveComponent("el-sub-menu");
    return _openBlock(), _createBlock(_component_el_sub_menu, {
        index: _ctx.index,
        "popper-class": "pe-submenu_popup"
    }, {
        title: _withCtx(()=>[
                _ctx.data.icon ? (_openBlock(), _createElementBlock("pg-icon", {
                    key: 0,
                    class: "menu-icon",
                    name: _ctx.data.icon
                }, null, 8, _hoisted_1)) : _createCommentVNode("", true),
                _createElementVNode("span", {
                    class: "pe-menu-collape-btn-span",
                    title: _ctx.data.name
                }, _toDisplayString(_ctx.data.name), 9, _hoisted_2)
            ]),
        default: _withCtx(()=>[
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.children || [], (menu, i)=>{
                    return _openBlock(), _createElementBlock(_Fragment, null, [
                        !menu.children || !menu.children.length ? (_openBlock(), _createBlock(_component_el_menu_item, {
                            key: i,
                            index: menu.link,
                            onClick: ($event)=>_ctx.jumpMenu(menu.link)
                        }, {
                            title: _withCtx(()=>[
                                    _createElementVNode("span", {
                                        title: menu.nameShow || menu.name,
                                        class: _normalizeClass([
                                            menu.children && menu.children.length ? 'pe-menu-collape-btn-span' : 'pe-menu-collape-btn-span-no'
                                        ])
                                    }, _toDisplayString(menu.nameShow || menu.name), 11, _hoisted_4)
                                ]),
                            default: _withCtx(()=>[
                                    menu.icon ? (_openBlock(), _createElementBlock("pg-icon", {
                                        key: 0,
                                        class: "menu-icon",
                                        name: menu.icon
                                    }, null, 8, _hoisted_3)) : _createCommentVNode("", true)
                                ]),
                            _: 2
                        }, 1032, [
                            "index",
                            "onClick"
                        ])) : (_openBlock(), _createBlock(_component_SubmenuListPc, {
                            key: _ctx.index + '-' + i,
                            data: menu,
                            index: _ctx.index + '-' + i
                        }, null, 8, [
                            "data",
                            "index"
                        ]))
                    ], 64);
                }), 256))
            ]),
        _: 1
    }, 8, [
        "index"
    ]);
}
